import Axios from 'axios';
import util from '@/util';
import { LoadConfig } from './config';
import router from '@/router';

const axios = Axios.create();

// 请求拦截器
axios.interceptors.request.use(config => {
  const cookieObj = util.getCookieObj();
  const urlParams = util.getUrlParams();
  config.headers['x-fs-locale'] = cookieObj.lang;
  config.headers['accept-language'] = cookieObj.lang;
  config.headers['fs-out-appid'] = urlParams.fsAppId || urlParams.appId;
  return config;
});

// 响应拦截器
axios.interceptors.response.use(
  response => {
    console.log(response);
    if (!response.data.Result) {
      const data = response.data;
      response.data = {
        Result: {
          FailureCode: 0,
          StatusCode: 0,
        },
        Value: data,
      };
    }

    const statusCode = response.data.Result.StatusCode === 0;
    const errorCode =
      response.data.Value && (response.data.Value.errCode || response.data.Value.errorCode || 'C120040000');
    const errorMessage =
      (response.data.Value && (response.data.Value.errMsg || response.data.Value.errorMessage)) ||
      response.data.Result.FailureMessage ||
      response.data.errMsg;

    if (statusCode && (errorCode === 'C120040000' || errorCode === 's120050000')) {
    } else if (errorCode === 'C320046304') {
      // 链接失效 跳转失效页面
      router
        .replace({
          name: 'error',
          params: {
            errMsg: $t('链接已失效！'),
          },
        })
        .catch(() => {});
    } else if (errorCode === 'C320040102') {
      // 无权限
      router
        .replace({
          name: 'error',
          params: {
            errMsg: $t('无知识分类可见范围权限'),
          },
        })
        .catch(() => {});
    } else {
      if (response.config.errorAlert === undefined || response.config.errorAlert > 1) {
        // Toast.fail(errorMessage);
        return Promise.reject(errorMessage);
      }
    }
    let res = response.data.Value;
    // 当前用户uid
    if (response.data.Result && response.data.Result.UserInfo && !res.ResultUserInfo) {
      res = Object.assign(res, { ResultUserInfo: response.data.Result.UserInfo });
    }
    return res;
    // return response.data.Value;
  },
  error => {
    return Promise.reject(error.message);
  }
);

const Api = {};
Api.use = model => {
  model.install(Api);
};
Api.get = (url, data, config = new LoadConfig()) => {
  config.loading();
  return new Promise((resolve, reject) => {
    axios
      .get(url, { params: data })
      .then(response => {
        config.success();
        resolve(response);
      })
      .catch(error => {
        config.fail(error);
        reject(error);
      });
  });
};

Api.post = (url, data, config = new LoadConfig()) => {
  config.loading();
  return new Promise((resolve, reject) => {
    axios
      .post(url, data)
      .then(response => {
        config.success();
        resolve(response);
      })
      .catch(error => {
        config.fail(error);
        reject(error);
      });
  });
};
export default Api;
